import { useEffect, useState } from 'react';
import { createRoute, stripSearchParams } from '@tanstack/react-router';

import { rootRoute, useAppRouterInitial } from '../routerBase';
import {
  EVENTS_SEARCH_DEFAULTS,
  parseEventsSearch,
} from '../../hooks/useEventsRouterSearch';
import { TableViewSkeleton } from '../../components/Skeleton/TableViewSkeleton';
import { useTranslation } from '../../hooks/useTranslation';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
// Type-only imports so the per-route bundles stay split — the runtime modules
// are loaded via dynamic import() inside each route's effect (see below).
import type EventManagement from '../../components/EventManagement/index';

export const eventsIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/events',
  validateSearch: parseEventsSearch,
  search: { middlewares: [stripSearchParams(EVENTS_SEARCH_DEFAULTS)] },
  component: function EventsIndexRoute() {
    const { eventSalespersons, currentUser } = useAppRouterInitial();
    const { t } = useTranslation();
    useDocumentTitle(t('common.page_titles.events'));
    const [Component, setComponent] = useState<typeof EventManagement | null>(null);
    useEffect(() => {
      import('../../components/EventManagement/index').then((mod) => {
        setComponent(() => mod.default);
      });
    }, []);
    if (!Component) {
      return <TableViewSkeleton label={t('common.loading')} />;
    }
    return <Component salespersons={eventSalespersons} currentUser={currentUser} />;
  },
});
